export default [
  // action_find_product
  {
    type: 'find_product_success',
    name: 'Producto encontrado'
  },
  {
    type: 'find_product_empty',
    name: 'Resultado vacío'
  },
  {
    type: 'find_product_failed',
    name: 'Error de búsqueda'
  },
  // action_update_delivery
  {
    type: 'edit_order_failed',
    name: 'Error editando orden'
  },
  {
    type: 'edit_order_success',
    name: 'Orden editada'
  },
  // action_edit_order
  {
    type: 'out_of_stock',
    name: 'Sin inventario disponible'
  },
  {
    type: 'no_quantity',
    name: 'Cantidad no especificada'
  },
  //analyze_text
  {
    type: 'analyze_success',
    name: 'Análisis completado'
  },
  {
    type: 'analyze_failed',
    name: 'Error en análisis'
  },
  // input_validation
  {
    type: 'input_text',
    name: 'Siguiente bloque'
  },
  {
    type: 'input_number_success',
    name: 'Número válido'
  },
  {
    type: 'input_number_fail',
    name: 'Número no válido'
  },
  {
    type: 'input_email_success',
    name: 'Email válido'
  },
  {
    type: 'input_email_fail',
    name: 'Email no válido'
  },
  {
    type: 'input_phone_success',
    name: 'Teléfono válido'
  },
  {
    type: 'input_phone_fail',
    name: 'Teléfono no válido'
  },
  {
    type: 'input_cp_success',
    name: 'Código postal válido'
  },
  {
    type: 'input_cp_fail',
    name: 'Código postal no válido'
  },
  {
    type: 'input_rfc_success',
    name: 'RFC válido'
  },
  {
    type: 'input_rfc_fail',
    name: 'RFC no válido'
  },
  {
    type: 'input_curp_success',
    name: 'CURP válido'
  },
  {
    type: 'input_curp_fail',
    name: 'CURP no válido'
  },
  {
    type: 'input_phonenip_success',
    name: 'NIP válido'
  },
  {
    type: 'input_phonenip_fail',
    name: 'NIP no válido'
  },
  {
    type: 'force_input',
    name: 'Siguiente bloque'
  },
  {
    type: 'input_number_strict_success',
    name: 'Operación exitosa'
  },
  {
    type: 'input_number_strict_fail',
    name: 'Operación fallida'
  },
  {
    type: 'input_time',
    name: 'Siguiente bloque'
  },
  {
    type: 'input_address_success',
    name: 'Operación exitosa'
  },
  {
    type: 'input_address_fail',
    name: 'Operación fallida'
  },
  {
    type: 'input_image_success',
    name: 'Operación exitosa'
  },
  {
    type: 'input_image_fail',
    name: 'Operación fallida'
  },
  {
    type: 'input_file_success',
    name: 'Operación exitosa'
  },
  {
    type: 'input_file_fail',
    name: 'Operación fallida'
  },
  {
    type: 'input_location_success',
    name: 'Operación exitosa'
  },
  {
    type: 'input_location_fail',
    name: 'Operación fallida'
  },
  {
    type: 'input_address_or_location_success',
    name: 'Operación exitosa'
  },
  {
    type: 'input_address_or_location_fail',
    name: 'Operación fallida'
  },
  // view
  {
    type: 'view_success',
    name: 'Siguiente bloque'
  },
  // ai_nlp
  {
    type: 'intent_validation',
    name: 'Intención/entidades encontradas'
  },
  // validate
  {
    type: 'compare_success',
    name: 'Comparaciones cumplidas'
  },
  {
    type: 'compare_failed',
    name: 'Todas comparaciones fallidas'
  },
  // show_categories
  {
    type: 'show_categories_failed',
    name: 'Error mostrando categorías'
  },
  // action_show_products
  {
    type: 'show_products_empty',
    name: 'Resultado vacío'
  },
  {
    type: 'show_products_failed',
    name: 'Error mostrando productos'
  },
  // web_search
  {
    type: 'request_success',
    name: 'Petición exitosa'
  },
  {
    type: 'request_failed',
    name: 'Error en petición'
  },
  // search_first
  {
    type: 'search_success',
    name: 'Búsqueda exitosa'
  },
  {
    type: 'search_null',
    name: 'Búsqueda fallida'
  },
    // contacts
    {
      type: 'input_contacts_success',
      name: 'Validación exitosa'
    },
    {
      type: 'input_contacts_fail',
      name: 'Validación fallida'
    },
  // payment_url
  {
    type: 'get_payment_url_success',
    name: 'Liga generada con exito'
  },
  {
    type: 'pay_success',
    name: 'Pago exitoso'
  },
  {
    type: 'pay_error',
    name: 'Error en la transacción'
  },
  // request_pay
  {
    type: 'pay_not_requested',
    name: 'Error al generar la liga de pago'
  },
  // extension
  {
    type: 'extension_success',
    name: 'En operación exitosa'
  },
  {
    type: 'extension_failed',
    name: 'En operación fallida'
  },
  // rule
  {
    type: 'rule_success',
    name: 'Regla cumplida'
  },
  {
    type: 'rule_failed',
    name: 'No cumple la regla'
  },
  // available_admins
  {
    type: 'admins_found',
    name: 'Admins disponibles'
  },
  {
    type: 'no_admins_found',
    name: 'No admins disponibles'
  },
  {
    type: 'hubspot_success',
    name: 'Cliente encontrado/creado'
  },
  {
    type: 'hubspot_failed',
    name: 'Cliente no encontrado/creado'
  },
  // save_in_entity
  {
    type: 'save_success',
    name: 'Guardado exitosamente'
  },
  {
    type: 'save_failed',
    name: 'Error al guardar'
  },
  // edit_in_entity
  {
    type: 'edit_success',
    name: 'Actualización exitosa'
  },
  {
    type: 'edit_failed',
    name: 'Error al editar'
  },
  // auth_code
  {
    type: 'auth_success',
    name: 'Autenticación exitosa'
  },
  {
    type: 'auth_failed',
    name: 'Código incorrecto / vencido'
  },
  // arithmetic
  {
    type: 'arithmetic_success',
    name: 'En operación exitosa'
  },
  {
    type: 'arithmetic_failed',
    name: 'En operación fallida'
  },
  // matcher
  {
    type: 'match_success',
    name: 'Coincidencias encontradas'
  },
  {
    type: 'match_failed',
    name: 'Sin resultados'
  },
  // date_operator
  {
    type: 'date_operator_success',
    name: 'En operación exitosa'
  },
  {
    type: 'date_operator_fail',
    name: 'En operación fallida'
  },
  // customer_feedback
  {
    type: 'feedback_success',
    name: 'Retroalimentación exitosa'
  },
  {
    type: 'feedback_error',
    name: 'Error en retroalimentación'
  },
  // show_list
  {
    type: 'show_list_success',
    name: 'Acción exitosa'
  },
  {
    type: 'show_list_failed',
    name: 'Acción fallida'
  },
  // set_bot_image
  {
    type: 'bot_image_failed',
    name: 'Acción fallida'
  },
  // create_or_update_contact | contact_add_platform
  {
    type: 'contact_failed',
    name: 'Acción fallida'
  },
  {
    type: 'missing_contact_info',
    name: 'Información incompleta'
  },
  {
    type: 'contact_success',
    name: 'Acción exitosa'
  },
  // cross_platform
  {
    type: 'cross_platform_fail',
    name: 'Acción fallida'
  },
  {
    type: 'cross_platform_success',
    name: 'Acción exitosa'
  },
  // cross_platform
  {
    type: 'cross_platform_fail',
    name: 'Acción fallida'
  },
  {
    type: 'cross_platform_success',
    name: 'Acción exitosa'
  },
  // near_pickup_location
  {
    type: 'near_pickup_location_false',
    name: 'Acción fallida'
  },
  {
    type: 'near_pickup_location_true',
    name: 'Acción exitosa'
  },
  // in_coverage_area
  {
    type: 'in_coverage_area_false',
    name: 'Acción fallida'
  },
  {
    type: 'in_coverage_area_true',
    name: 'Acción exitosa'
  },
  // soap_request
  { type: 'missing_params', name: 'Parámetros incompletos' },
  { type: 'json_error', name: 'Error en JSON' },
  { type: 'soap_success', name: 'Acción exitosa' },
  { type: 'soap_fail', name: 'Acción fallida' },
  // action_get_order
  { type: 'get_order_success', name: 'En acción exitosa' },
  { type: 'get_order_fail', name: 'En acción fallida' },
  // LLM
  {
    type: 'llm_success',
    name: 'LLM exitoso'
  },
  {
    type: 'llm_fail',
    name: 'LLM fallido'
  },
  {
    type: 'create_event_success',
    name: 'Acción exitosa'
  },
  {
    type: 'create_event_error',
    name: 'Acción fallida'
  },
  {
    type: 'invalid_calendar',
    name: 'Calendario invalido'
},  {
    type: 'auto_payment_success',
    name: 'Pago exitoso'
  },
  {
    type: "auto_payment_failed",
    name: "Pago fallido"
  }
]
